export default "__VITE_ASSET__CjtP_RdT__"